import React, { useState } from 'react'
import { NewClient } from '../services/client';
import toast from 'react-hot-toast';
import ProfileNav from '../components/ProfileNav';

const CreateClient = () => {
  const [name, setName] = useState("")
  const [email, setEmail] = useState("")
  const [ip, setIp] = useState("")
  const [loading, setLoad] = useState(false)
  const [ipError, setIpError] = useState("")

  const isValidIP = (ip) => {
    const ipRegex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;
    return ipRegex.test(ip);
  };

  const createClient = async (e) => {
    e.preventDefault();

    // Validate IP
    if (!ip.trim()) {
      setIpError("IP address is required.");
      return;
    }

    if (!isValidIP(ip)) {
      setIpError("Please enter a valid IP address.");
      return;
    }

    setIpError(""); // Clear previous error

    try {
      const response = await NewClient({
        name: name,
        email: email,
        ip: ip,
      });

      if (response.success === true) {
        setLoad(true);
        toast.success("Client created successfully!");
      }
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center py-4">
        <h1 className="text-navy-blue text-2xl font-bold">
          Create Client
        </h1>
        <div>
          <ProfileNav />
        </div>
      </div>

      <div className='p-5 flex justify-center items-center'>
        <form onSubmit={createClient} className='bg-white gap-3 w-[35%] p-5 flex flex-col shadow-sm rounded'>
          <p className='text-2xl text-orange-500 font-semibold flex justify-center items-center'>Create Client</p>

          <div className='flex flex-col gap-2'>
            <label>Name</label>
            <input
              onChange={(e) => setName(e.target.value)}
              className='w-[90%] p-2 rounded-sm bg-slate-100 shadow-sm'
              placeholder='Enter name'
              value={name}
            />
          </div>

          <div className='flex flex-col gap-2'>
            <label>Email</label>
            <input
              onChange={(e) => setEmail(e.target.value)}
              className='w-[90%] p-2 rounded-sm bg-slate-100 shadow-sm'
              placeholder='Enter your email address'
              value={email}
            />
          </div>

          <div className='flex flex-col gap-2'>
            <label>IP</label>
            <input
              onChange={(e) => setIp(e.target.value)}
              className={`w-[90%] p-2 rounded-sm bg-slate-100 shadow-sm ${ipError ? "border border-red-500" : ""}`}
              placeholder='Enter IP'
              value={ip}
            />
            {ipError && <p className="text-red-500 text-sm">{ipError}</p>}
          </div>

          <div className="mt-5">
            <button
              className="bg-text-orange w-full h-[50px] text-white rounded-md disabled:opacity-50"
              type="submit"
              disabled={!ip.trim()}
            >
              Create Client
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default CreateClient;
